import {
	DEADLINE_WARNING_DAYS,
	DEADLINE_STATUS_COLORS
} from '../../../../helpers/constants';


const UNKNOWN = 'Нет данных';
const PERMANENT = 'Бессрочно';

const isPermanent = (record) => record.state === 'ok' && record.to_deadline == null;

const deadlineToStatus = (to_deadline, record) => {
	if (isPermanent(record)) return { text: PERMANENT, color: DEADLINE_STATUS_COLORS.ok };
	if (to_deadline == null) return { text: UNKNOWN, color: DEADLINE_STATUS_COLORS.no_date };
	if (to_deadline >= 0 && to_deadline <= DEADLINE_WARNING_DAYS) return { text: String(to_deadline), color: DEADLINE_STATUS_COLORS.warning };
	if (to_deadline > DEADLINE_WARNING_DAYS) return { text: String(to_deadline), color: DEADLINE_STATUS_COLORS.ok };
	if (to_deadline < 0) return { text: String(to_deadline), color: DEADLINE_STATUS_COLORS.overdue };
};


export const buildColumns = (templatesByCode) => [
	{
		title: 'Работник',
		dataIndex: 'user',
		key: 'user',
		render: (user) => user ?? '—',
		sorter: (a, b) => (a.user || '').localeCompare(b.user || '', 'ru')
	},
	{
		title: 'Подразделение',
		dataIndex: 'division',
		key: 'division',
		render: (division) => division ?? '—',
		sorter: (a, b) => (a.division || '').localeCompare(b.division?.title || '', 'ru')
	},
	{
		title: 'Профессия',
		key: 'profession',
		dataIndex: 'profession',
		render: (profession) => profession ?? '—',
		sorter: (a, b) =>
			((a.user?.profession?.title ?? '').trim())
				.localeCompare((b.user?.profession?.title ?? '').trim(), 'ru')
	},
	{
		title: 'Документ',
		key: 'template',
		dataIndex: 'template',
		render: (template) => templatesByCode[template]?.title ?? template,
		sorter: (a, b) => {
			const nameA = templatesByCode[a.template]?.title || a.template || '';
			const nameB = templatesByCode[b.template]?.title || b.template || '';
			return nameA.localeCompare(nameB, 'ru');
		}
	},
	{
		title: 'Дата',
		dataIndex: 'issued',
		key: 'issued',
		render: (issued) => issued ? new Date(issued).toLocaleDateString('ru-RU') : 'не указано',
		sorter: (a, b) => new Date(a.issued) - new Date(b.issued),
		align: 'center'
	},
	{
		title: 'Срок',
		key: 'to_deadline',
		dataIndex: 'to_deadline',
		render: (to_deadline, record) => {
			const { text, color } = deadlineToStatus(to_deadline, record);
			return <span style={{ color, fontWeight: 600 }}>{text}</span>;
		},
		sorter: (a, b) => {
			const va = isPermanent(a) ? Infinity : a.to_deadline ?? -Infinity;
			const vb = isPermanent(b) ? Infinity : b.to_deadline ?? -Infinity;
			return (vb - va) || 0;
		},
		align: 'center',
		width: 120
	}
];


